import { render, staticRenderFns } from "./GmbAttributeChip.vue?vue&type=template&id=e8adcacc&scoped=true&"
import script from "./GmbAttributeChip.vue?vue&type=script&lang=js&"
export * from "./GmbAttributeChip.vue?vue&type=script&lang=js&"
import style0 from "./GmbAttributeChip.vue?vue&type=style&index=0&id=e8adcacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8adcacc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
